import React from "react";

export default function MainSection(props: { children?: React.ReactNode }) {

    return (
        <main className="main-container h-100">
            {/* <div className={classes.toolbar} /> */}
                {props.children}
        </main>
    );
}